"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCartRebuild = void 0;
const enums_1 = require("../../enums");
const pushToDataLayer_1 = require("../pushToDataLayer");
function trackCartRebuild(cart) {
    const productInfos = cart.items.map(item => `${item.product.manufacturerSku}_${item.quantity}`);
    const eventLabel = productInfos.join('/');
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: 'JS_Event',
        eventCategory: enums_1.EventCategory.Cart,
        eventAction: 'Rebuild',
        eventLabel,
    });
}
exports.trackCartRebuild = trackCartRebuild;
//# sourceMappingURL=trackCartRebuild.js.map